import { Injectable } from '@angular/core';

export interface Job {
  id: number;
  title: string;
  department: string;
  type: string;
  location: string;
  applications: number;
  date: string;
  status: 'Active' | 'Closed' | 'Pending';
}

export interface Candidate {
  id: string;
  name: string;
  email: string;
  mobile: string;
  role: string;
  location: string;
  assessmentScore: number;
  interviewScore: number;
  status: 'shortlisted' | 'applied' | 'interview_scheduled' | 'rejected' | 'selected' | 'new' | 'assessment_pending' | 'assessment_completed' | 'ai_interview_pending' | 'mock_done' | 'ai_done';
  final_status?: string;
  appliedDate: string;
  experienceType: 'fresher' | 'experienced' | 'educator';
  currentTitle?: string;
  currentCompany?: string;
  experience?: string;
  currentCtc?: string;
  expectedCtc?: string;
  prefCity1?: string;
  prefCity2?: string;
  prefCity3?: string;
  subject?: string;
  specialization?: string;
  previousInstitute?: string;
  resume_url?: string;
  job_title?: string;
  education?: string;
  yearOfPassing?: string;
  cgpa?: string;
  skills?: string;
  core_expertise?: string;
}

export interface Assessment {
  id: number;
  title: string;
  subTitle: string;
  duration: number;
  questionsCount: number;
  candidatesCount: number;
  status: 'Active' | 'Draft';
}

@Injectable({
  providedIn: 'root'
})
export class RecruiterDataService {
  stats = {
    totalJobs: 24,
    activeJobs: 12,
    applicationsReceived: 486,
    interviewsCompleted: 38,
    assessmentsConducted: 156,
    shortlistedCandidates: 67
  };

  recentJobs: Job[] = [
    { id: 1, title: 'Software Developer', department: 'Engineering', type: 'Full-Time', location: 'Mumbai, India', applications: 45, date: 'Apr 30, 2026', status: 'Active' },
    { id: 2, title: 'Business Analyst', department: 'Operations', type: 'Internship', location: 'Delhi, India', applications: 32, date: 'Apr 25, 2026', status: 'Active' },
    { id: 3, title: 'Marketing Executive', department: 'Marketing', type: 'Full-Time', location: 'Bangalore, India', applications: 28, date: 'Apr 10, 2026', status: 'Closed' },
    { id: 4, title: 'Data Scientist', department: 'Data Science', type: 'Full-Time', location: 'Remote', applications: 56, date: 'May 15, 2026', status: 'Active' }
  ];

  recentApplications = [
    { name: 'Priya Sharma', email: 'priya@iitd.ac.in', role: 'Software Developer', date: 'Apr 7, 2026', status: 'Shortlisted' },
    { name: 'Rahul Kumar', email: 'rahul@bits.ac.in', role: 'Business Analyst', date: 'Apr 6, 2026', status: 'Applied' },
    { name: 'Anita Patel', email: 'anita@nitt.ac.in', role: 'Data Scientist', date: 'Apr 6, 2026', status: 'Interview' },
    { name: 'Vikash Singh', email: 'vikash@vit.ac.in', role: 'Software Developer', date: 'Apr 5, 2026', status: 'Rejected' }
  ];

  allJobs: Job[] = [
    { id: 1, title: 'Software Developer', department: 'Engineering', type: 'Full-Time', location: 'Mumbai, India', applications: 45, date: 'Apr 30, 2026', status: 'Active' },
    { id: 2, title: 'Business Analyst', department: 'Operations', type: 'Internship', location: 'Delhi, India', applications: 32, date: 'Apr 25, 2026', status: 'Active' },
    { id: 3, title: 'Marketing Executive', department: 'Marketing', type: 'Full-Time', location: 'Bangalore, India', applications: 28, date: 'Apr 10, 2026', status: 'Closed' },
    { id: 4, title: 'Data Scientist', department: 'Data Science', type: 'Full-Time', location: 'Remote', applications: 56, date: 'May 15, 2026', status: 'Active' },
    { id: 5, title: 'UI/UX Designer', department: 'Design', type: 'Contract', location: 'Remote', applications: 19, date: 'May 1, 2026', status: 'Pending' },
    { id: 6, title: 'DevOps Engineer', department: 'Engineering', type: 'Full-Time', location: 'Pune, India', applications: 22, date: 'May 20, 2026', status: 'Active' }
  ];

  allCandidates: Candidate[] = [
    { id: '1', name: 'Priya Sharma', email: 'priya@iitd.ac.in', mobile: '+91 98765 43210', role: 'Software Developer', location: 'Bengaluru', assessmentScore: 85, interviewScore: 78, status: 'shortlisted', appliedDate: 'Apr 7, 2026', experienceType: 'fresher' },
    { id: '2', name: 'Rahul Kumar', email: 'rahul@bits.ac.in', mobile: '+91 98765 11111', role: 'Business Analyst', location: 'Hyderabad', assessmentScore: 72, interviewScore: 65, status: 'applied', appliedDate: 'Apr 6, 2026', experienceType: 'fresher' },
    { id: '3', name: 'Anita Patel', email: 'anita@nitt.ac.in', mobile: '+91 98765 22222', role: 'Data Scientist', location: 'Chennai', assessmentScore: 90, interviewScore: 88, status: 'interview_scheduled', appliedDate: 'Apr 6, 2026', experienceType: 'fresher' },
    { id: '4', name: 'Vikash Singh', email: 'vikash@vit.ac.in', mobile: '+91 98765 33333', role: 'Software Developer', location: 'Pune', assessmentScore: 45, interviewScore: 42, status: 'rejected', appliedDate: 'Apr 5, 2026', experienceType: 'fresher' },
    { id: '5', name: 'Neha Gupta', email: 'neha@example.com', mobile: '+91 99887 76655', role: 'DevOps Engineer', location: 'Bengaluru', assessmentScore: 82, interviewScore: 80, status: 'selected', appliedDate: 'Apr 4, 2026', experienceType: 'experienced', currentTitle: 'Senior DevOps Engineer', currentCompany: 'Acme Corp', experience: '6 years', currentCtc: '18', expectedCtc: '26', prefCity1: 'Bengaluru', prefCity2: 'Pune', prefCity3: 'Hyderabad' },
    { id: '6', name: 'Amit Joshi', email: 'amit@example.com', mobile: '+91 99887 11111', role: 'UI/UX Designer', location: 'Mumbai', assessmentScore: 70, interviewScore: 84, status: 'applied', appliedDate: 'Apr 3, 2026', experienceType: 'experienced', currentTitle: 'Lead Designer', currentCompany: 'PixelWorks', experience: '5 years', currentCtc: '14', expectedCtc: '20', prefCity1: 'Mumbai', prefCity2: 'Bengaluru', prefCity3: 'Remote' },
    { id: '7', name: 'Kavitha Reddy', email: 'kavitha@example.com', mobile: '+91 99887 22222', role: 'Marketing Executive', location: 'Hyderabad', assessmentScore: 76, interviewScore: 79, status: 'shortlisted', appliedDate: 'Apr 2, 2026', experienceType: 'experienced', currentTitle: 'Marketing Manager', currentCompany: 'BrandHub', experience: '8 years', currentCtc: '16', expectedCtc: '22', prefCity1: 'Hyderabad', prefCity2: 'Bengaluru', prefCity3: 'Chennai' },
    { id: '8', name: 'Dr. Meera Iyer', email: 'meera.iyer@example.edu', mobile: '+91 98001 13345', role: 'Educator', location: 'Bengaluru', assessmentScore: 92, interviewScore: 88, status: 'shortlisted', appliedDate: 'Apr 8, 2026', experienceType: 'educator', subject: 'Mathematics', specialization: 'Algebra', experience: '9', currentCtc: '12', expectedCtc: '18', previousInstitute: 'Delhi Public School', prefCity1: 'Bengaluru', prefCity2: 'Hyderabad', prefCity3: 'Pune' },
    { id: '9', name: 'Arjun Mehta', email: 'arjun.mehta@example.edu', mobile: '+91 98760 20222', role: 'Educator', location: 'Mumbai', assessmentScore: 78, interviewScore: 74, status: 'applied', appliedDate: 'Apr 7, 2026', experienceType: 'educator', subject: 'Physics', specialization: 'Thermodynamics', experience: '5', currentCtc: '8.5', expectedCtc: '15', previousInstitute: 'FIITEE', prefCity1: 'Mumbai', prefCity2: 'Pune', prefCity3: 'Bengaluru' },
    { id: '10', name: 'Sunita Rao', email: 'sunita.rao@example.edu', mobile: '+91 96800 33333', role: 'Educator', location: 'Hyderabad', assessmentScore: 85, interviewScore: 90, status: 'selected', appliedDate: 'Apr 1, 2026', experienceType: 'educator', subject: 'Chemistry', specialization: 'Organic Chemistry', experience: '12', currentCtc: '15', expectedCtc: '22', previousInstitute: 'Aakash Institute', prefCity1: 'Hyderabad', prefCity2: 'Bengaluru', prefCity3: 'Chennai' },
    { id: '11', name: 'Rohit Sen', email: 'rohit.sen@example.edu', mobile: '+91 96982 66688', role: 'Educator', location: 'Kolkata', assessmentScore: 68, interviewScore: 72, status: 'applied', appliedDate: 'Apr 4, 2026', experienceType: 'educator', subject: 'Computer Science', specialization: 'Data Structures', experience: '4', currentCtc: '8', expectedCtc: '14', previousInstitute: 'Vidyamandir Classes', prefCity1: 'Kolkata', prefCity2: 'Bengaluru', prefCity3: 'Pune' }
  ];

  allAssessments: Assessment[] = [
    { id: 1, title: 'Software Developer - Aptitude + Coding', subTitle: 'Evaluate data structures, algorithms and coding standards', duration: 60, questionsCount: 35, candidatesCount: 45, status: 'Active' },
    { id: 2, title: 'Business Analyst - Logical Reasoning', subTitle: 'Evaluate critical reasoning, data analysis and verbal skills', duration: 45, questionsCount: 25, candidatesCount: 32, status: 'Active' },
    { id: 3, title: 'wqeqwe', subTitle: 'Evaluate core features and basic questions', duration: 50, questionsCount: 4, candidatesCount: 0, status: 'Active' }
  ];
}


export const CANDIDATE_STATUS_LABELS: Record<string, string> = {
  new: 'New',
  applied: 'Applied',
  assessment_pending: 'Assessment Pending',
  assessment_completed: 'Assessment Completed',
  ai_interview_pending: 'AI Interview Pending',
  interview_scheduled: 'Interview Scheduled',
  shortlisted: 'Shortlisted',
  selected: 'Selected',
  rejected: 'Rejected'
};